export default __webpack_public_path__ + "static/webRotator/svg/faf5065e2514587c2315cb74880b3e84.svg";